var map = {
	"./OrderSuccess/locales/zh-TW.json": 927,
	"./PersonalCentre/locales/zh-TW.json": 928,
	"./cart/locales/zh-TW.json": 929,
	"./checkout/locales/zh-TW.json": 930,
	"./collection/locales/zh-TW.json": 931,
	"./common/locales/zh-TW.json": 932,
	"./forgottenPassword/locales/zh-TW.json": 933,
	"./layouts/locales/zh-TW.json": 934,
	"./pages/locales/zh-TW.json": 935,
	"./products/locales/zh-TW.json": 936,
	"./register/locales/zh-TW.json": 937
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 926;